import React from "react";

export default (props) => <div className="tab-content">{props.children}</div>;



// WEBPACK FOOTER //
// ./src/lib_react_adminlte/template/tab/TabsContent.jsx